import { getDashboardUrl } from './api'

const REDIRECT_PATHS = {
  content: '/web-concierge/customize',
  web: '/web-concierge/content',
} as const

export function buildDashboardRedirectUrl(
  type: 'web' | 'content',
  conciergeId: string,
  email?: string,
): string {
  const redirectPath = REDIRECT_PATHS[type] ?? REDIRECT_PATHS.web
  let redirectUrl = `${getDashboardUrl()}${redirectPath}?conciergeId=${encodeURIComponent(conciergeId)}`

  if (email) {
    redirectUrl += `&email=${encodeURIComponent(email)}`
  }

  return redirectUrl
}
